import { CategoryItemsInterface, ItemInterface, SummaryItemInterface } from "@/interface/business/item.interface";
import { NAME_LOCAL_NAME_KEY } from "@/enums/orders.enum";
import store from "@/store";

export default class ItemCategory implements CategoryItemsInterface {
  id: string;
  name: string;
  local_name: string;
  items?: Array<ItemInterface | SummaryItemInterface>;
  constructor(data) {
    this.id = data.id || "";
    this.name = data.name || "";
    this.local_name = data.local_name || "";
    this.items = data.items;
  }

  /**
   * get item name by language key
   * @return {string}
   */
  public getDisplayName(): string {
    const { state } = <any>store;
    return this?.[NAME_LOCAL_NAME_KEY[state.App.lang]] || this.name;
  }
}
